export default __webpack_public_path__ + "static/media/Pi-Original.63b89046.svg";